import React, { useState, useEffect } from 'react';
import Footer from "./Footer";
import Header from "./Header";
import './Lector.css';

import arturito from '../assets/img/arturito.webp';
import img_pixart from '../assets/img/pixart.png';
import img_office from '../assets/img/office.png';

export default function Lector() {
  const [filter, setFilter] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const images = [
    { src: img_pixart, alt: 'Pixart' },
    { src: img_office, alt: 'Office' }
  ];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const MIN_LENGTH = 9;

  // Rotador de imágenes del carrusel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  const handleFilterChange = (event) => {
    setFilter(event.target.value.trim());
    setData(null);
    setError(null);
  };

  // 🔍 Consulta a la API
  useEffect(() => {
    if (filter.length >= MIN_LENGTH) {
      setLoading(true);
      setError(null);

      fetch(`https://pjb.edu.ar/api/entregas_sityc/index.php?cue=${filter}`)
        .then((response) => response.json())
        .then((json) => {
          if (json.status === "ok" && json.data) {
            setData(json.data);
          } else {
            setData(null);
            setError("No se encontraron resultados para el CUE ingresado.");
          }
          setLoading(false);
        })
        .catch(() => {
          setError("Error al obtener los datos.");
          setLoading(false);
        });
    }
  }, [filter]);

  return (
    <div>
      <Header />
      <div className="container no-select no-print mt-5">

        <div className='card shadow-sm'>
          <div className='card-header bg-light fw-bold'>Buscador de entregas</div>
          <div className='card-body'>

            {/* Buscador */}
            <div className="row justify-content-center">
              <div className="col-12 col-md-6 text-center">
                <label className="form-label fw-semibold">Número de CUE</label>
                <input
                  type="text"
                  className="form-control text-center shadow-sm"
                  value={filter}
                  onChange={handleFilterChange}
                  placeholder="Ej: 140562800"
                  maxLength={9}
                />
              </div>
            </div>

            {/* Mensajes de estado */}
            <div className="text-center mt-3">
              {loading && <p>Cargando datos...</p>}
              {error && <p className="text-danger">{error}</p>}
            </div>

            {/* Información del colegio */}
            {data && (
              <div className="d-flex justify-content-center mt-4">
                <div
                  className="card border-0 shadow-sm w-100 w-md-75"
                  style={{
                    background: "#f8f9fa",
                    borderRadius: "12px",
                    maxWidth: "700px"
                  }}
                >
                  <div className="card-body text-start">
                    <h5 className="card-title text-primary mb-3">
                      {data.nombre}
                    </h5>
                    <div className="row">
                      <div className="col-12 col-md-6 mb-2">
                        <p className="mb-1"><strong>CUE:</strong> {data.cue}</p>
                        <p className="mb-1"><strong>Localidad:</strong> {data.localidad}</p>
                      </div>
                      <div className="col-12 col-md-6 mb-2">
                        <p className="mb-1"><strong>Departamento:</strong> {data.departamento}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Imagen y tarjetas de entregas */}
            {data ? (
              <div className="text-center mt-4">
                <img
                  src={arturito}
                  alt="Tecnopresentito"
                  style={{
                    width: "160px",
                    marginBottom: "20px",
                    animation: "float 3s ease-in-out infinite"
                  }}
                />

                <div className="row justify-content-center">
                  {/* Netbooks */}
                  <div className="col-12 col-md-5 mb-3">
                    <div className="card border-0 shadow h-100">
                      <div className="card-body text-center">
                        <p className="fw-semibold text-secondary">Netbooks entregadas</p>
                        <h2 className="text-success fw-bold">
                          {parseInt(data.netbooks) > 0 ? data.netbooks : "0"}
                        </h2>
                      </div>
                    </div>
                  </div>

                  {/* Carros */}
                  <div className="col-12 col-md-5 mb-3">
                    <div className="card border-0 shadow h-100">
                      <div className="card-body text-center">
                        <p className="fw-semibold text-secondary">Carros entregados</p>
                        <h2 className="text-primary fw-bold">
                          {parseInt(data.carros) > 0 ? data.carros : "0"}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mensaje condicional si tiene carro */}
                {parseInt(data.carros) >= 1 && (
                  <div
                    className="alert alert-info mt-4 mx-auto"
                    style={{
                      maxWidth: "750px",
                      borderRadius: "10px",
                      backgroundColor: "#e8f4fd",
                      borderColor: "#b6e0fe"
                    }}
                  >
                    <p className="mb-1">
                      <strong>Importante:</strong><br />
                      Estimado/a podrá retirar el carro completando el siguiente formulario:&nbsp;
                      <a
                        href="https://forms.office.com/r/n3C9qz3dSQ"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fw-semibold text-primary"
                      >
                        https://forms.office.com/r/n3C9qz3dSQ
                      </a>.
                    </p>
                    <p className="mb-0">
                      En el mismo encontrará las instrucciones del lugar de retiro.
                    </p>
                  </div>
                )}
              </div>
            ) : (
              !loading && !error && (
                <p className="mt-4 text-center text-muted">
                  Ingrese el número de CUE (por ejemplo <strong>140562800</strong>) para consultar
                  las entregas de computadoras y carros asignadas a su escuela.
                </p>
              )
            )}
          </div>
        </div>

        {/* Card inferior: tutoriales */}
        <div className='card mt-4 shadow-sm'>
          <div className='card-body'>
            <div className='row'>
              <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center">
                <h3 className="text-center">
                  <a target="_blank" className="text-secondary" href="https://educacioncba.edu.ar/manualesytutoriales/">
                    Manuales y tutoriales
                  </a>
                </h3>
                <p className="mt-4 text-muted">
                  Accedé a tutoriales y guías de ayuda sobre las entregas y el uso de los equipos.
                </p>
                <h4 className="text-center mt-4">
                  <a href="https://educacioncba.edu.ar/manualesytutoriales/">Ir a manuales y tutoriales</a>
                </h4>
              </div>
              <div className='col-12 col-md-6'>
                <div className="carousel-container">
                  <img
                    src={images[currentImageIndex].src}
                    alt={images[currentImageIndex].alt}
                    className="carousel-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  );
}
